import React from 'react'
import { Box, Typography } from '@material-ui/core'

type ProposalInfoContainerProps = {
  title: string,
  description: string,
  isSmallTitle?: boolean
}

export const ProposalInfoContainer: React.FC<ProposalInfoContainerProps> = (props) => {
  const { title, description, isSmallTitle, children } = props

  return (
    <Box sx={{
      display: 'flex',
      gap: 3,
      width: '100%',
      flexDirection: 'column'
    }}>
      <Box sx={{
        display: 'flex',
        gap: 1,
        flexDirection: 'column'
      }}>
        <Typography
          variant={isSmallTitle ? 'airbnbH4' : 'airbnbH3'}
        >
          {title}
        </Typography>
        <Typography variant='airbnbBody1'>{description}</Typography>
      </Box>

      {children}
    </Box>
  )
}
